import { i18n } from "../../../plugins/vue-i18n";

const validateRRC = {
  validate: validate,
  message: i18n.t("VALIDATION_ERRORS.validateRRC")
};

function validate(input) {
  let isDigits = /^\d+$/;
  let isCorrectLength = input.length == 9;

  let nPart = input.substring(0, 4);
  let pPart = input.substring(4, 6);
  let xPart = input.substring(6, 9);

  let isCorrectNPart = isDigits.test(nPart) && nPart != "0000";
  let isCorrectPPart = /^[0-9A-Z]{2}$/.test(pPart) && pPart != "00";
  let isCorrectXPart = isDigits.test(xPart) && xPart != "000";

  return isCorrectLength && isCorrectNPart && isCorrectPPart && isCorrectXPart;
}

export default validateRRC;
